<template>
<div class="page-wrapper">
  <div>
    <h3 class="title">费用信息</h3>
    <div>
      <div>
        <div class="inline-b mr8 mb16">
          <span class="label">主合同号：</span>
          <Input type="text" v-model="parentContractCode" class="item-width" @on-blur="findParentContractInfo"></Input>
        </div>
        <div class="inline-b mr8 mb16">
          <span class="label">客户名称：</span>
          <Input :disabled="true" type="text" v-model="customerName" class="item-width"></Input>
        </div>
        <div class="inline-b">
          <span class="label">账单期数：</span>
          <Select v-model="periods" @on-change="getEpsBillDetail" :disabled="!isCheckContract"  class="item-width">
            <Option value=''>请选择</Option>
            <Option v-for="item in periodsList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
        </div>
      </div>
      <div>
        <div class="inline-b mr8 mb16">
          <span class="label">开始日期：</span>
          <DatePicker :disabled="true" class="item-width" v-model="billStartDate"  format="yyyy-MM-dd" placeholder="开始日期"></DatePicker>
        </div>
        <div class="inline-b mr8 mb16">
          <span class="label">结束日期：</span>
          <DatePicker :disabled="true" class="item-width" v-model="billEndDate"  format="yyyy-MM-dd" placeholder="结束日期"></DatePicker>
        </div>
        <div class="inline-b">
          <span class="label">应收金额：</span>
          <Input :disabled="true" type="text" v-model="receiptTotal" class="item-width error-color"></Input>
        </div>
        <div class="inline-b">
          <span class="label">已收金额：</span>
          <Input :disabled="true" type="text" v-model="receivedTotal" class="item-width error-color"></Input>
        </div>
        <div class="inline-b">
          <span class="label">待收金额：</span>
          <Input :disabled="true" type="text" v-model="receivingTotal" class="item-width error-color"></Input>
        </div>
      </div>
    </div>
  </div>
  <div class="mt36">
    <table-list
      :columns="columns"
      :data="gatherList"
      :loading="loading"
      :show-page="false"
    >
    </table-list>
    <a href="javascript:;" @click="showBillingDetail">{{`应收账单明细(${detailListCount})`}}</a>
  </div>
  <div  class="mt36" v-if="cardsList.length">
    <h3 class="title">卡券信息</h3>
    <div class="flex">
      <span class="label">租金卡：</span>
      <div>
        <div class="cards mb8" v-for="(item,i) in cardsList" :class="{checked:item.status==1}" :key="`card${i}`" @click="clickCard(i)">{{(item.money/100).toFixed(2)}}</div>
      </div>
    </div>
  </div>
  <div class="mt36">
    <h3 class="title">收款</h3>
    <a href="javascript:;" @click="addCollections">添加收款</a>
    <div v-for="(item,i) in collections" v-if="item.status===1">
      <Icon v-if="i!== 0" class="delete-icon" size="18" color="#F56356" type="android-remove-circle" @click.native="deleteItem(i)"></Icon>
      <collection-item :key="`collection${i}`" :ref="`collection${i}`" :parentContractCode="parentContractCode" :projectFid="projectFid" :receiptMethodList="receiptMethodList" @inputPayment = "inputPayment" @show-img="showImg"></collection-item>
    </div>
  </div>
  <div  class="btn-wrap">
    <Button type="primary" size="large" @click="save" :disabled="!isCheckContract || received" :loading="btnLoading">
      <span>提交</span>
    </Button>
  </div>
  <billing-details :n="billingKey" :tableData="detailList"></billing-details>
   <img-show :n="showImgKey" :src="imgSrc"></img-show>
</div>
</template>

<script type="text/ecmascript-6">
import { getFinContractInfo, getEpsBillDetail, queryRentCard, batchSaveCertificate } from 'api/accountsReceivable'
import {getBaseUrl} from "@/utils/public";
import {getToken} from "@/utils/auth";
import BillingDetails from './components/BillingDetails';
import CollectionItem from './../components/CollectionItem';
import TableList from 'components/TableList/index';
import ImgShow from 'components/ImgShow/index'

export default {
  name:'enterprisecollection',
  components:{
    TableList,
    BillingDetails,
    CollectionItem,
    ImgShow
  },
  created(){
    this.key = this.$route.query.key
    this.baseUrl = getBaseUrl()
    this.token = getToken()
  },
  activated(){
    this.key = this.$route.query.key
    //this.clearData()
  },

  props:{
    n:{
      type:Number,
      default:0
    }
  },
  computed:{
    detailListCount(){
      return this.detailList.length
    },
    tag() {
      return this.$store.state.tagsView.visitedViews.find(tag => {
        return tag.path===this.$route.path
      });
    },
    clickedCardsList(){
      let arr = []
      this.cardsList.forEach( item => {
        if(item.status === 1){
          arr.push({
            code:item.code,
            money:(item.money/100).toFixed(2),
            type:item.type
          })
        }
      })
      return arr
    },
    cardsTotal(){
      return this.clickedCardsList.reduce((sum,cur) => {
        return sum + +cur.money
      },0)
    },
    fzIndex(){
      return this.initGatherList.findIndex( item => item.costCodeName ==='房租')
    }
  },
  watch:{
    key(val){
      this.clearData()
    }
    // isFirst(val){
    //   if(val==0 && this.isActive){
    //     this.clearData()
    //   }
    // },
    // parentContractCode(val){
    //   if(val&&this.isFirst){
    //     this.findParentContractInfo()
    //   }
    // }
  },
  data () {
    return {
      key:0,
      isCheckContract:false,
      received:false,
      // isActive:false,
      showImgKey:0,
      imgSrc:'',
      baseUrl:'',
      customerUid:'',
      projectFid:'',
      billingKey:0,
      loading:false,
      btnLoading:false,
      cardsList:[],
      receiptMethodList:[],
      // 合同信息
      parentContractCode:'',
      customerName:'',
      periods:0,
      billEndDate:'',
      billStartDate:'',
      receiptTotal:'',
      receivedTotal:'',
      receivingTotal:'',
      inintReceivedTotal : 0,
      periodsList:[],
      columns:[
        {
          title: '费用项目',
          key: 'costCodeName',
          align: 'center'
        },
         {
          title: '应收金额',
          key: 'receiptBillAmount',
          align: 'center'
        },
         {
          title: '卡券抵扣金额',
          key: 'deductibleAmount',
          align: 'center',
          render: (h,params) => {
            return h('span',params.index === this.fzIndex ? this.cardsTotal.toFixed(2) : new Number(0).toFixed(2))
          }
        },
        {
          title: '已收金额',
          key: 'receivedBillAmount',
          align: 'center'
        },
        {
            title: '待收金额',
            key: 'unReceivedBillAmount',
            align: 'center'
        },
      ],
      initGatherList:[],
      gatherList:[],
      detailList:[],
      collections:[{
        index:0,
        status:1
      }]
    };
 },
  methods:{
    addCollections(){
      let len = this.collections.length
      this.collections.push({
        index:len,
        status:1
      })
    },
    clearData(){
      this.customerUid = ''
      this.projectFid = ''
      this.cardsList = []
      this.receiptMethodList = []
      this.parentContractCode = ''
      this.customerName = ''
      this.periods = 0
      this.billEndDate = ''
      this.billStartDate = ''
      this.receiptTotal = ''
      this.receivedTotal = ''
      this.receivingTotal = 0
      this.inintReceivedTotal = 0
      this.periodsList = []
      this.initGatherList = []
      this.gatherList = []
      this.detailList = []
      this.collections = [{
        index:0,
        status:1
      }]
      this.clearColectionForm = true
      if(this.$route.query.parentContractCode){
        this.parentContractCode = this.$route.query.parentContractCode
        this.findParentContractInfo()
      }
    },
    clickCard(i){
      if(this.cardsList[i].status==0){
        this.cardsList[i].status = 1
      }else {
         this.cardsList[i].status = 0
      }
      if(this.fzIndex > -1){
        if(this.cardsTotal > this.initGatherList[this.fzIndex].unReceivedBillAmount){
          // 租金卡总额大于房租待付 当前租卡不选  status=0，提醒
          this.cardsList[i].status = 0
          this.$Modal.warning({
            title: '消息提醒',
            content: '租金卡卡券总额大于房租待收金额，此租金卡不可选'
          });
        }else{
          // 触发抵扣事件
          this.inputPayment()
        }
      }
    },
    useRentCards(){
      let fzIndex = this.fzIndex
      this.gatherList[fzIndex].deductibleAmount = this.cardsTotal
      this.gatherList[fzIndex].unReceivedBillAmount = this.gatherList[fzIndex].unReceivedBillAmount - this.gatherList[fzIndex].deductibleAmount
      this.gatherList[fzIndex].receivedBillAmount = this.gatherList[fzIndex].receiptBillAmount - this.gatherList[fzIndex].unReceivedBillAmount
    },
    closeTag(){
      if(this.$route.query.parentContractCode){
        this.$router.push({ name: 'workbench'})
      }
      else {
        // this.$router.push({ name: 'accountsreceivable'})
        this.$routerGo({name: 'accountsreceivable'})
      }

    },
    deleteItem(i){
      this.collections[i].status = 0
      if(this.$refs[`collection${i}`][0].formData.factPayment){
        this.inputPayment()
      }
    },
    findParentContractInfo(){

      this.isCheckContract = false
      if(this.parentContractCode){
        getFinContractInfo(this.parentContractCode).then(res => {
          this.customerName = res.data.customerName

          this.periodsList = res.data.payNumList
          this.periods = ''

          if(this.$route.query.curPlanNum){
            this.periods = parseInt(this.$route.query.curPlanNum)
          }

          this.receiptMethodList = res.data.receiptMethodList
          this.customerUid = res.data.customerUid
          this.projectFid = res.data.projectFid
          this.isCheckContract = true
        }).then(res => {

          this.getRentCard(this.customerUid)
        })
      } else {
        this.$Message.info('请输入要添加的合同号！')
      }
    },
    inputPayment(){
      if(this.received) return
      let total = this.getTotal()
      let tmp = total
      let len = this.gatherList.length
      this.receivedTotal = (+tmp + this.cardsTotal + +this.inintReceivedTotal).toFixed(2)
      this.receivingTotal = (this.receiptTotal - this.receivedTotal).toFixed(2)<0 ? 0:(this.receiptTotal - this.receivedTotal).toFixed(2)
      // if(+this.receivedTotal > +this.receiptTotal){
      //   this.$Modal.warning({
      //     title: '消息提醒',
      //     content: '实收金额大于应收金额，请重新输入！'
      //   });
      //   return
      // }
      // 数据重新赋值
      this.gatherList.forEach((item,i) => {
        item.unReceivedBillAmount = this.initGatherList[i].unReceivedBillAmount
        item.receivedBillAmount = this.initGatherList[i].receivedBillAmount
        item.receiptBillAmount = this.initGatherList[i].receiptBillAmount
      })

      if(this.clickedCardsList.length > 0) {
        this.useRentCards()
      }
      for(let i = 0; i < len; i++){
        if(tmp > +this.gatherList[i].unReceivedBillAmount){
          tmp = tmp - this.gatherList[i].unReceivedBillAmount
          this.gatherList[i].receivedBillAmount = (+this.gatherList[i].receivedBillAmount + +this.gatherList[i].unReceivedBillAmount).toFixed(2)
          this.gatherList[i].unReceivedBillAmount = new Number(0).toFixed(2)

        }else {
          this.gatherList[i].unReceivedBillAmount = (+this.gatherList[i].unReceivedBillAmount - tmp).toFixed(2)
          this.gatherList[i].receivedBillAmount = (+this.gatherList[i].receiptBillAmount - this.gatherList[i].unReceivedBillAmount).toFixed(2)
          return
        }
      }
    },
    getRentCard(customerUid){
      queryRentCard(customerUid).then( res => {
        this.cardsList = res.data
        this.cardsList.forEach( item => {
          this.$set(item,'status',0)
        })
      })
    },
    getTotal(){
      let formList = this.collections.filter( item => {
        return item.status === 1
      })
      let total = formList.reduce((sum,cur,i) => {
        let factPayment = +this.$refs[`collection${cur.index}`][0].formData.factPayment
        if(factPayment) {
        return  sum + factPayment
        } else {
          return sum
        }
      },0)
      return total
    },
    getEpsBillDetail(){
      if(!this.periods)return
      getEpsBillDetail(this.parentContractCode,this.periods).then( res => {
        this.initGatherList = res.data.gatherList
        this.gatherList = JSON.parse(JSON.stringify(res.data.gatherList))
        this.detailList = res.data.detailList
        this.billEndDate  = res.data.billEndDate
        this.billStartDate  = res.data.billStartDate
        this.receiptTotal = res.data.receiptTotal
        this.receivedTotal = res.data.receivedTotal
        this.inintReceivedTotal = res.data.receivedTotal
        this.receivingTotal = (res.data.receiptTotal-res.data.receivedTotal).toFixed(2)
        if(this.receiptTotal === this.receivedTotal){
          this.received = true
          this.$Modal.warning({
            title: '消息提醒',
            content: '此期账单已收，请选择其他期数账单'
          });
        } else {
          this.received = false
        }
      })
    },
    showImg(img){
      this.imgSrc =img
      this.showImgKey++
    },
    showBillingDetail() {
      this.billingKey++
    },
    save(){
      if(!this.periods){
        this.$Modal.warning({
          title: '消息提醒',
          content: '请选择账单期数！'
        });
        return
      }
      if(+this.receiptTotal > +this.receivedTotal ){
        this.$Modal.warning({
          title: '消息提醒',
          content: '实收金额小于应收金额，请重新录入收款金额！'
        });
        return
      }
      if (+this.receiptTotal < +this.receivedTotal) {
        this.$Modal.confirm({
          title: '消息提醒',
          content: '实收金额大于应收金额，将产生多收款！<br>备注：企业合同多收款默认摊销到第一个子合同',
          onOk:()=>{
            this.saveSkip()
          }
        });
      }
      if (+this.receiptTotal == +this.receivedTotal) {
        this.saveSkip()
      }

    },
    saveSkip(){
      let data = {
        contractParentCode:this.parentContractCode,
        periods:this.periods,
      }

      if(this.clickedCardsList.length){
        let cards = this.clickedCardsList.map(item => {
          return {
            code:item.code,
            money:(item.money*100).toFixed(0),
            type:item.type
          }
        })
        data = Object.assign({},data,{cards:cards})
      }
      let receipts = this.validateCollections()
      if(receipts){
        this.btnLoading = true
        data = Object.assign({},data,{receipts:receipts})
        batchSaveCertificate(data).then( res=>{
          this.$Message.success('提交成功!');
          this.closeTag()
          this.btnLoading = false
        }).catch( res => {
          this.btnLoading = false
        })
      }
    },
    validateCollections(){
      let formList = this.collections.filter( item => {
        return item.status === 1
      })
      let collections = []
      let result = formList.every( item => {
        collections.push(this.$refs[`collection${item.index}`][0].formValidate())
        return this.$refs[`collection${item.index}`][0].formValidate()
      })
      if(result) {
       return collections
      }else{
        return false
      }
    }
 }
}
</script>
<style scoped>
.label {
  display: inline-block;
  width: 80px;
  text-align: right;
}
.item-width {
  width:150px;
}
a{
  display: inline-block;
  margin-top: 12px;
}

.upload-wrap {
  display: inline-block;
  line-height: 1;
  padding: 10px 4px;
}
 .imgwidth {
  width: 167px;
  height: 118px;
}
.upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #DDDEE1;
  width: 167px;
  height: 118px;
  border: 1px dashed rgb(220, 220, 220);
  box-sizing: border-box;
  text-align: center;
}
.ivu-upload {
  position: relative;
}
.ivu-upload  a {
  position :absolute;
  right: 0;
  bottom: -6px;
}
.upload.error {
  border-color:#F56356;
}
a.error-color {
  color:#F56356;
  bottom: -18px;

}
.btn-wrap {
width: 100%;
text-align: center;
}
.cards {
  display: inline-block;
  width:80px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #DDDEE1;
  border-radius: 2px;
  text-align: center;
  margin-left: 16px;
}
.cards.checked {
 border: 1px solid #CFA868;
}
.flex {
  display: flex;
}
.flex .label {
  flex: 0 0 60px;
}
.info {
  padding-left: 8px;
  font-weight: 600;
}
.ivu-col {
  line-height: 2.5;
}
</style>

